import React from 'react';
import Image from '../AppImage';

const Footer = () => {
  const euLogos = [
  {
    id: 1,
    name: 'EU Funding',
    src: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763512232/Flag_of_Europe.svg_ku7fyb.png",
    alt: 'European Union co-financing logo indicating EU support for cross-border cooperation project',
    link: 'https://european-union.europa.eu/index_en'
  },
  {
    id: 2,
    name: 'CBC Serbia-Montenegro',
    src: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763512227/CBC-SRB-MNE-logo-2014_2020-beli_rhls3s.png",
    alt: 'Cross-Border Cooperation Serbia-Montenegro program logo for 2014-2020 period',
    link: null
  },
  {
    id: 3,
    name: 'Serbia Coat of Arms',
    src: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763512232/Coat_of_arms_of_Serbia_small.svg_f7vhbg.png",
    alt: 'Official coat of arms of the Republic of Serbia with national heraldic symbols',
    link: null
  },
  {
    id: 4,
    name: 'Montenegro Coat of Arms',
    src: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763512231/Coat_of_arms_of_Montenegro.svg_s0bops.png",
    alt: 'Official coat of arms of Montenegro featuring national eagle and crown symbols',
    link: null
  }];



  const currentYear = new Date()?.getFullYear();

  return (
    <footer className="bg-primary text-primary-foreground py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">Creative Twinning</h3>
            <p className="text-primary-foreground/80 text-sm leading-relaxed">
              Connecting Serbia and Montenegro through shared heritage and sustainable tourism development.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <div className="space-y-2 text-sm">
              <div><a href="/thematic-trails-overview" className="text-primary-foreground/80 hover:text-primary-foreground">Thematic Trails</a></div>
              <div><a href="/heritage-interactive-map" className="text-primary-foreground/80 hover:text-primary-foreground">Heritage Map</a></div>
              <div><a href="/tourism-offerings" className="text-primary-foreground/80 hover:text-primary-foreground">Tourism Offerings</a></div>
              <div><a href="/about-project" className="text-primary-foreground/80 hover:text-primary-foreground">About Project</a></div>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <div className="space-y-2 text-sm text-primary-foreground/80">
              <div>info@creativetwinning.eu</div>
              <div>+381 11 123 4567</div>
              <div>Belgrade, Serbia</div>
            </div>
          </div>
        </div>
        
        {/* EU Disclaimer */}
        <div className="border-t border-primary-foreground/20 mt-8 pt-8">
          <div className="text-center mb-6">
            <p className="text-sm text-primary-foreground/90 max-w-4xl mx-auto leading-relaxed">
              Projekat je sufinansiran od strane Evropske unije u okviru IPA II programa prekogranične saradnje Srbija - Crna Gora (2014-2020).
            </p>
          </div>
          
          {/* EU Logos */}
          <div className="flex flex-wrap items-center justify-center gap-6 mb-6">
            {euLogos?.map((logo) => {
              const logoElement =
              <div key={logo?.id} className="h-12 w-auto flex items-center">
                  <Image
                  src={logo?.src}
                  alt={logo?.alt}
                  className="h-full w-auto object-contain max-w-[120px] filter brightness-100" />

                </div>;


              return logo?.link ?
              <a
                key={logo?.id}
                href={logo?.link}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity duration-300">

                  {logoElement}
                </a> :
              logoElement;
            })}
          </div>
          
          <div className="text-center text-sm text-primary-foreground/60">
            <p>&copy; {currentYear} Creative Twinning Project. Funded by the European Union.</p>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;